// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","wrapper":"ChangeBuildTypeSelect__wrapper--k_","select":"ChangeBuildTypeSelect__select--u7","selectPopup":"ChangeBuildTypeSelect__selectPopup--NG"};